import { useEffect } from 'react'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { loginRequest } from './auth/msalConfig'
import { Dashboard } from './pages/Dashboard'
import { LoadingScreen } from './pages/LoadingScreen'

/**
 * Top-level app component. Handles the auth gate: if the user isn't signed in,
 * kick off a redirect to Entra. Otherwise render the dashboard.
 */
export default function App() {
  const { instance, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    // Only trigger login when no auth flow is in progress and we're not signed in
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      instance.loginRedirect(loginRequest).catch((err) => {
        console.error('Login redirect failed:', err)
      })
    }
  }, [inProgress, isAuthenticated, instance])

  if (!isAuthenticated || inProgress !== InteractionStatus.None) {
    return <LoadingScreen message="Signing you in…" />
  }

  return <Dashboard />
}
